import React, { useRef, useState } from "react"

import classNames from "gpages/utils/classnames"

import * as styles from "./nav.module.scss"
import logoImg from "@images/gclogo.png"
import Clickable from "../clickable"
import { useScrollEvent } from "gpages/hooks/common"
import Icon from "../icon"
import { useAppContext } from "@src/context/appContext"

import submitImg from "@images/btn-submit.png"
// import enrollSmImg from "@images/sm/btn-enroll.png"
import config from "@config"

const Nav = ({ location }) => {
  const { renderItem } = useAppContext()
  const [dropdownVisble, setDropdownVisible] = useState(false)
  const [visible, setVisible] = useState(true)
  const prevScrollTopRef = useRef(0)

  useScrollEvent(() => {
    const scrollTop = window.scrollY
    const prevTop = prevScrollTopRef.current
    if (scrollTop <= 500) {
      setVisible(true)
      return
    }
    if (prevTop >= 0) {
      setVisible(scrollTop < prevTop)
    }
    prevScrollTopRef.current = scrollTop
  })

  return (
    <nav
      className={classNames(styles.nav, {
        [styles.isDropdown]: dropdownVisble,
        [styles.isHide]: !visible,
      })}
    >
      <Clickable
        className={styles.enrollBtn}
        appNavTo={config.links.jiheGameSubmitGuide}
      >
        {renderItem(submitImg, submitImg)}
      </Clickable>
      <Clickable
        className={styles.dropDownMask}
        onClick={() => {
          setDropdownVisible(false)
        }}
      />
      <div className={styles.navInner}>
        <img src={logoImg} alt="logo" className={styles.logo} />
        <div className={styles.right}>
          <Clickable
            className={styles.menuBtn}
            onClick={() => {
              setDropdownVisible((prev) => !prev)
            }}
          >
            {dropdownVisble ? <Icon icon="close" /> : <Icon icon="burger" />}
          </Clickable>
          <div className={styles.menu}>
            <ul>
              {[
                { title: "介绍及流程", href: "#intro" },
                { title: "游戏开发赛道", href: "#lane_unity" },
                {
                  title: "AI插件赛道",
                  href: "#lane_plugin",
                },
                {
                  title: "正向价值游戏赛道",
                  href: "#lane_g4g",
                },
              ].map(({ title, href }) => {
                return (
                  <li key={title}>
                    <Clickable newWindow={false} href={href} onClick={() => {}}>
                      {title}
                    </Clickable>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Nav
